<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
            <h4 class="fw-bold">Borrowings - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />

      <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
        <div class="row">
          <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
            <!--<h5 class="fw-bolder font-size-16 ">Borrowings</h5>-->
            <div class="mb-3">
              <p class="mt-4">Please enter notes on borrowings that are included within creditors.</p>
              <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
            <div class="col-xxl-11 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <form [formGroup]="CreateBorrowingsFormGroup">

                <div class="row mt-4">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <h6 class="fw-bolder font-size-16"></h6>
                              </div>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="col-lg-12 text-center">
                                    <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                                    <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="col-lg-12 text-center">
                                    <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                                    <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 ps-0 ps-lg-5">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Within one year</label>
                              </div>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="WithinOneYear" (blur)="Calculations()" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="WithinOneYear_LY" (blur)="Calculations()" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Between one and five years</label>
                              </div>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="BetweenOneAndFiveYears" (blur)="Calculations()" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="BetweenOneAndFiveYears_LY" (blur)="Calculations()" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Over five years</label>
                              </div>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="OverFiveYears" (blur)="Calculations()" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" maxlength="11" [appTooltip]="showBubbledata" class="form-control AccountNumber text-end" appNumberdirective formControlName="OverFiveYears_LY" (blur)="Calculations()" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                              <div class="pt-2 mb-4">
                                <label class="m-t-5 font-weight-600">Total</label>
                              </div>
                            </div>
                            <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                              <div class="row">
                                <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end " formControlName="BorrowingsTotal" />
                                  </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                                  <div class="input-group mb-3">
                                    <div class="input-group-text">
                                      <span class=" theme-color font-weight-600">£</span>
                                    </div>
                                    <input type="text" class="form-control text-end " formControlName="BorrowingsTotal_LY" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                    <label>Please enter any additional information in the field below.</label>
                    <div class="mb-3">
                      <textarea class="form-control txt-area allowSpecialChars" [appTooltip]="showBubbledata" rows="6" appNumberdirective maxlength="4000" formControlName="AdditionalInformation"></textarea>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
      <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
        <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
        <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
      </div>
    </div>
  </div>
</div>
